
import { Component, Vue } from "vue-property-decorator"
import { Action, State } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import SkeletonLoader from "@/components/SkeletonLoader.vue"

import TenantList from "@/components/System/TenantList.vue"
import SystemUsers from "@/components/System/SystemUsers.vue"
import SystemHistory from "@/components/System/SystemHistory.vue"

import { SystemUser } from "@/types/user"

import systemApi from "@/services/api/api_System"
import Page from "@/components/New/Page/Page.vue"
import { Wormhole } from "portal-vue"
import ModalPageTarget from "@/components/Config/ModalPageTarget.vue"

enum SystemPages {
	Tenants,
	Users,
	History
}

@Component({
	components: {
		"page": Page,
		"skeleton": SkeletonLoader,
		"scrollbar": VuePerfectScrollbar,
		"tenant-list": TenantList,
		"system-users": SystemUsers,
		"system-history": SystemHistory,
		"modal-page-target": ModalPageTarget
	}
})
export default class System extends Vue {
	SystemPages = SystemPages

	@State public systemUser!: SystemUser

	@Action userInit!: () => Promise<void>
	@Action finishLogin!: () => Promise<void>

	public currentPage: SystemPages = SystemPages.Tenants

	private get hasSubheaderContent () {
		return Wormhole.hasContentFor("subheader")
	}

	async endSupportAccess () {
		await systemApi.endTenantAccess()
		this.userInit()
	}

	async enterTenant () {
		await systemApi.switchToTenant()
		this.finishLogin()
	}
}

